import { Button, Form, Input, Select, Spin } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";
import { filterOption, requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";

export default function () {
    const navigate = useNavigate();
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        setLoading(true);
        axiosInstance
            .get(`fine/${id}`)
            .then(({ data }) => {
                const mappedEmp = data.employees.map((x) => ({
                    label: x.fullName,
                    value: x.id,
                    key: x.id,
                }));
                form.setFieldValue("employees", mappedEmp);
                console.log(mappedEmp);
            })
            .finally(() => setLoading(false));
    }, []);

    const onFinish = (form) => {
        setLoading(true);
        axiosInstance
            .post(`fine/${id}/decision`, {
                ...form,
                employees: (form.employees ?? []).map((x) => x.value),
            })
            .then(() => navigate(-1))
            .finally(() => setLoading(false));
    };
    return (
        <Spin spinning={loading}>
            <Form onFinish={onFinish} layout="vertical" form={form}>
                <Form.Item name={"employees"} label="Responsabili" rules={[requiredField]}>
                    <DebounceSelect
                        mode="multiple"
                        fetchOptions={async (query) => {
                            const { data } = await axiosInstance.get("employeeCompact", {
                                params: { query, startDate: "1900-01-01", endDate: "9999-12-31" },
                            });
                            return data.map((x) => ({ label: x.fullName, value: x.id }));
                        }}
                    />
                </Form.Item>
                <Form.Item name={"notes"} label="Note">
                    <Input.TextArea />
                </Form.Item>
                <Form.Item style={{textAlign:'end'}}>
                    <Button type="primary" htmlType="submit">Conferma</Button>
                </Form.Item>
            </Form>
        </Spin>
    );
}
